import { FC } from 'react';

export const MultiKnowledgeQuestion: FC = () => {
  return <div>TODO multi knowledge</div>;
};
